(function(window) {
  const testId = 'SIAB-US-CP-SB-AB005';
  const variantId = 'variant-1';

  waitFor(priceEl)
    .then(runVariant)
    .catch((err) => console.error(testId, err));

  function runVariant(priceEl) {
    addBadge(priceEl);
    listenForPriceChange();
    document.body.classList.add(testId);
    console.log(`${testId}: ${variantId}`);
  }

  function addBadge(priceEl) {
    const saveAmount = getSaveAmount(priceEl);

    if (saveAmount) {
      priceEl.insertAdjacentHTML('beforeend', `<div class="${testId}-sale-badge">ahorra ${saveAmount}%</div>`)
      priceEl.classList.add(`${testId}-redesigned`);
      isLongPriceCountry() && priceEl.classList.add('long-price');
    }
  }

  function getSaveAmount(priceEl) {
    const fullPrice = priceEl.querySelector('.product__price--compare') && priceEl.querySelector('.product__price--compare').textContent.trim();
    const salePrice = priceEl.querySelector('.sale-price') && priceEl.querySelector('.sale-price').textContent.trim();
    let saveAmount = 0;

    if (fullPrice && salePrice) {
      saveAmount = Math.round((1 - (strToNum(salePrice) / strToNum(fullPrice))) * 100);
    }

    return saveAmount;
  }

  function strToNum(str) {
    const match = str.match(/\d+,?\d+\.?\d*/g)[0];

    return match && +match.replace(',', '');
  }

  function isLongPriceCountry() {
    const countries = ['IL', 'EG', 'AE', 'MA', 'TH'];
    const country = window.Shopify && window.Shopify.country;

    return country && countries.includes(country);
  }

  function listenForPriceChange() {
    document.addEventListener('click', e => {
      const isSkioEl = e.target.matches('.skio-group-container--available, .skio-group-container--available *')

      isSkioEl && setTimeout(updatePrice, 0);
    })
  }

  function updatePrice() {
    const badge = document.querySelector(`.${testId}-sale-badge`);
    const priceCont = priceEl()
    const saveAmount = priceCont && getSaveAmount(priceCont);

    if (badge && saveAmount) {
      badge.innerText = `ahorra ${saveAmount}%`
    }
  }

  function priceEl() {
    return document.querySelector('.product-single__price__prices');
  }

  function waitFor(condition, timeout) {
    const stopTime = typeof timeout === 'number' ? timeout : 7000;
    let stop = false;

    window.setTimeout(function() {
      stop = true;
    }, stopTime);

    // eslint-disable-next-line no-undef
    return new Promise(function(resolve, reject) {
      (function _innerWaitFor() {
        const value = condition();

        if (stop) {
          reject();
        } else if (value) {
          resolve(value);
        } else {
          window.setTimeout(_innerWaitFor, 50);
        }
      })();
    });
  }

})(typeof unsafeWindow === 'undefined' ? window : unsafeWindow);
//# sourceURL=SIAB-US-CP-SB-AB005-variant-1.js